(function () {
  if (window.BGAutoFreeGiftLoaded) {
    if (window.BGAutoFreeGift && typeof window.BGAutoFreeGift.schedule === 'function') {
      window.BGAutoFreeGift.schedule('section-reloaded', 250);
    }
    return;
  }

  window.BGAutoFreeGiftLoaded = true;

  var state = {
    inFlight: false,
    pending: false,
    timer: null,
    fetchPatched: false,
    wrapperTimer: null,
    wrapperAttempts: 0
  };

  function getRoot() {
    return document.querySelector('[data-bg-auto-free-gift][data-enabled="true"]');
  }

  function normalizeId(value) {
    return String(value || '')
      .replace('gid://shopify/ProductVariant/', '')
      .replace('gid://shopify/Product/', '')
      .trim();
  }

  function parseIds(value) {
    return String(value || '')
      .split(',')
      .map(normalizeId)
      .filter(Boolean);
  }

  function getRules(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-bg-auto-free-gift-rule]'))
      .map(function (ruleRoot) {
        var threshold = parseInt(ruleRoot.dataset.threshold || '0', 10);
        var giftVariantId = normalizeId(ruleRoot.dataset.giftVariantId);
        var productIds = parseIds(ruleRoot.dataset.qualifyingProductIds);

        if (!threshold || !giftVariantId || !productIds.length) {
          return null;
        }

        return {
          label: ruleRoot.dataset.ruleLabel || '',
          threshold: threshold,
          giftVariantId: giftVariantId,
          giftQuantity: parseInt(ruleRoot.dataset.giftQuantity || '1', 10) || 1,
          productIds: productIds,
          promoKey: ruleRoot.dataset.promoKey || '_auto_gift_promo',
          promoValue: ruleRoot.dataset.promoValue || 'BG_AUTO_FREE_GIFT'
        };
      })
      .filter(Boolean);
  }

  function getConfig() {
    var root = getRoot();

    if (!root) {
      return null;
    }

    var rules = getRules(root);

    if (!rules.length) {
      return null;
    }

    return {
      rules: rules,
      drawerSections: [], // cart drawer removed: skip heavy section render
      cartIconSection: root.dataset.cartIconSection || 'cart-icon-bubble'
    };
  }

  function getCartPageSectionId() {
    var cartRoot = document.getElementById('main-cart-items');
    return cartRoot && cartRoot.dataset ? cartRoot.dataset.id : null;
  }

  function getSections(config) {
    var sections = [];
    var cartSectionId = getCartPageSectionId();

    config.drawerSections.forEach(function (sectionId) {
      if (sectionId && sections.indexOf(sectionId) === -1) {
        sections.push(sectionId);
      }
    });

    if (cartSectionId && sections.indexOf(cartSectionId) === -1) {
      sections.push(cartSectionId);
    }

    if (config.cartIconSection && sections.indexOf(config.cartIconSection) === -1) {
      sections.push(config.cartIconSection);
    }

    return sections;
  }

  function getSectionsUrl() {
    return window.location.pathname || '/';
  }

  function cartRequest(path, payload, config) {
    var body = Object.assign({}, payload, {
      sections: getSections(config),
      sections_url: getSectionsUrl()
    });

    return fetch(path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Cart request failed: ' + response.status);
      }

      return response.json();
    });
  }

  function fetchCart() {
    return fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Cart read failed: ' + response.status);
      }

      return response.json();
    });
  }

  function isAutoGiftLine(item, rule) {
    var properties = item.properties || {};
    return normalizeId(item.variant_id) === rule.giftVariantId && properties[rule.promoKey] === rule.promoValue;
  }

  function getAutoGiftLine(cart, rule) {
    return (cart.items || []).find(function (item) {
      return isAutoGiftLine(item, rule);
    });
  }

  function getQualifyingQuantity(cart, rule) {
    return (cart.items || []).reduce(function (total, item) {
      var productId = normalizeId(item.product_id);

      if (normalizeId(item.variant_id) === rule.giftVariantId) {
        return total;
      }

      if (rule.productIds.indexOf(productId) === -1) {
        return total;
      }

      return total + Number(item.quantity || 0);
    }, 0);
  }

  function replaceFromSectionHtml(sectionHtml, selector) {
    if (!sectionHtml) {
      return;
    }

    var current = document.querySelector(selector);

    if (!current) {
      return;
    }

    var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var incoming = parsed.querySelector(selector);

    if (incoming) {
      current.innerHTML = incoming.innerHTML;
    }
  }

  function applyCartPageSection(sections) {
    var cartSectionId = getCartPageSectionId();

    if (!cartSectionId || !sections || !sections[cartSectionId]) {
      return;
    }

    replaceFromSectionHtml(sections[cartSectionId], '#main-cart-items .checkout-content-left');
    replaceFromSectionHtml(sections[cartSectionId], '#main-cart-footer');
  }

  function applyCartIconSection(sections, config) {
    if (!sections || !sections[config.cartIconSection]) {
      return;
    }

    var parsed = new DOMParser().parseFromString(sections[config.cartIconSection], 'text/html');
    var incoming = parsed.querySelector('[data-cart-count]');
    var current = document.querySelector('[data-cart-count]');

    if (incoming && current) {
      current.innerHTML = incoming.innerHTML;
      current.setAttribute('data-cart-count', incoming.getAttribute('data-cart-count') || current.getAttribute('data-cart-count') || '');
    }
  }

  function applyDrawerSections(sections) {
    if (!sections) {
      return;
    }

    var cartNotification = document.querySelector('cart-notification');

    if (cartNotification && typeof cartNotification.updateContent === 'function') {
      cartNotification.updateContent(sections);
    }
  }

  function applySections(response, config) {
    if (!response || !response.sections) {
      return;
    }

    applyCartPageSection(response.sections);
    applyCartIconSection(response.sections, config);
  }

  function notifyCartUpdated(cart) {
    if (typeof window.cartCount === 'function' && cart) {
      window.cartCount(cart);
    }

    if (typeof window.initFreeshippingGoal === 'function' && cart) {
      window.initFreeshippingGoal(cart);
    }

    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: {
        source: 'bg-auto-free-gift',
        cart: cart || null
      }
    }));
  }

  function addGift(rule, quantity, config) {
    var properties = {};
    properties[rule.promoKey] = rule.promoValue;

    return cartRequest('/cart/add.js', {
      id: Number(rule.giftVariantId),
      quantity: quantity,
      properties: properties
    }, config);
  }

  function changeGiftQuantity(giftLine, quantity, config) {
    return cartRequest('/cart/change.js', {
      id: giftLine.key,
      quantity: quantity
    }, config);
  }

  function addGiftUnified(rule, quantity, config) {
    if (window.bgSnackbar) window.bgSnackbar('\uD83C\uDF81 Free gift added');
    var properties = {};
    properties['_auto_gift_promo'] = 'BG_AUTO_FREE_GIFT';

    return cartRequest('/cart/add.js', {
      id: Number(rule.giftVariantId),
      quantity: quantity,
      properties: properties
    }, config);
  }

  function sync(reason) {
    var config = getConfig();

    if (!config) {
      return Promise.resolve();
    }

    if (state.inFlight) {
      state.pending = true;
      return Promise.resolve();
    }

    state.inFlight = true;
    state.pending = false;

    return fetchCart()
      .then(function (cart) {
        // --- Consolidated single-gift-line approach ---
        // Shopify only fires ONE automatic BXGY discount per cart.
        // Evaluate each rule, take the MAX gift sets from any single rule,
        // and manage ONE unified gift line in the cart.
        var actions = [];
        var bestDesired = 0;
        var bestRule = null;

        config.rules.forEach(function (rule) {
          var qualifyingQuantity = getQualifyingQuantity(cart, rule);
          var giftSets = rule.threshold > 0 ? Math.floor(qualifyingQuantity / rule.threshold) : 0;
          var desired = giftSets > 0 ? giftSets * rule.giftQuantity : 0;

          if (desired > bestDesired) {
            bestDesired = desired;
            bestRule = rule;
          }
        });

        // Find unified and legacy gift lines in the cart
        var unifiedPromoValue = 'BG_AUTO_FREE_GIFT';
        var unifiedGiftLine = null;
        var legacyGiftLines = [];

        (cart.items || []).forEach(function (item) {
          var properties = item.properties || {};
          var promoVal = properties['_auto_gift_promo'];

          if (!promoVal) {
            return;
          }

          // Check if this item is a gift variant from any rule
          var isGiftVariant = config.rules.some(function (rule) {
            return normalizeId(item.variant_id) === rule.giftVariantId;
          });

          if (!isGiftVariant) {
            return;
          }

          if (promoVal === unifiedPromoValue) {
            unifiedGiftLine = item;
          } else {
            // Legacy per-rule line (e.g. THROW_36_GET_SROLOC_OX_6)
            legacyGiftLines.push(item);
          }
        });

        // Remove any legacy per-rule gift lines
        legacyGiftLines.forEach(function (line) {
          actions.push(function () {
            return changeGiftQuantity(line, 0, config);
          });
        });

        if (bestDesired > 0 && bestRule) {
          if (!unifiedGiftLine) {
            actions.push(function () {
              return addGiftUnified(bestRule, bestDesired, config);
            });
          } else if (Number(unifiedGiftLine.quantity || 0) !== bestDesired) {
            actions.push(function () {
              return changeGiftQuantity(unifiedGiftLine, bestDesired, config);
            });
          }
        } else if (unifiedGiftLine) {
          actions.push(function () {
            return changeGiftQuantity(unifiedGiftLine, 0, config);
          });
        }

        if (!actions.length) {
          notifyCartUpdated(cart);
          return null;
        }

        return actions.reduce(function (chain, action) {
          return chain.then(function () {
            return action().then(function (response) {
              applySections(response, config);
              return response;
            });
          });
        }, Promise.resolve()).then(function () {
          return fetchCart().then(function (updatedCart) {
            notifyCartUpdated(updatedCart);
            return updatedCart;
          });
        });
      })
      .catch(function (error) {
        if (window.console && typeof window.console.warn === 'function') {
          window.console.warn('[BG auto free gift] ' + (reason || 'sync') + ' failed', error);
        }
      })
      .finally(function () {
        state.inFlight = false;

        if (state.pending) {
          schedule('pending-sync', 250);
        }
      });
  }

  function schedule(reason, delay) {
    window.clearTimeout(state.timer);
    state.timer = window.setTimeout(function () {
      sync(reason);
    }, typeof delay === 'number' ? delay : 500);
  }

  function shouldWatchFetch(input) {
    var url = '';

    if (typeof input === 'string') {
      url = input;
    } else if (input && input.url) {
      url = input.url;
    }

    return /\/cart\/(add|change|update|clear)\.js/.test(url);
  }

  function patchFetch() {
    if (state.fetchPatched || typeof window.fetch !== 'function') {
      return;
    }

    var originalFetch = window.fetch;
    state.fetchPatched = true;

    window.fetch = function () {
      var shouldSync = shouldWatchFetch(arguments[0]);
      var request = originalFetch.apply(this, arguments);

      if (shouldSync) {
        request.then(function () {
          schedule('cart-fetch', 700);
        }).catch(function () {});
      }

      return request;
    };
  }

  function wrapCartNotificationUpdater() {
    if (typeof window.updateCartNotification === 'function' && !window.updateCartNotification.BGAutoFreeGiftWrapped) {
      var originalUpdateCartNotification = window.updateCartNotification;

      window.updateCartNotification = function () {
        var result = originalUpdateCartNotification.apply(this, arguments);
        schedule('cart-notification-update', 1200);
        return result;
      };

      window.updateCartNotification.BGAutoFreeGiftWrapped = true;
      return;
    }

    if (state.wrapperAttempts >= 20) {
      return;
    }

    state.wrapperAttempts += 1;
    state.wrapperTimer = window.setTimeout(wrapCartNotificationUpdater, 500);
  }

  function bindEvents() {
    document.addEventListener('cart:updated', function (event) {
      if (event.detail && event.detail.source === 'bg-auto-free-gift') {
        return;
      }

      schedule('cart-updated', 650);
    });

    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches('cart-items input[name="updates[]"], .cart-notification-products .quantity-input')) {
        schedule('quantity-change', 900);
      }
    }, true);

    document.addEventListener('click', function (event) {
      if (event.target && event.target.closest('cart-items quantity-input, cart-items cart-remove-button, .cart-notification-products quantity-input, .cart-notification-products cart-remove-button')) {
        schedule('cart-click', 1200);
      }
    }, true);

    window.addEventListener('pageshow', function () {
      schedule('pageshow', 450);
    });
  }

  window.BGAutoFreeGift = {
    schedule: schedule,
    sync: sync
  };

  patchFetch();
  bindEvents();
  wrapCartNotificationUpdater();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      schedule('dom-ready', 450);
    });
  } else {
    schedule('initial', 450);
  }
})();
